import Vue from "vue";

export default {
	state: {},
	mutations: {},
	actions: {
		getSupplierBankInfo(_, idSupplier) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplierClientBank/" + idSupplier)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		createSupplierBankInfo(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("supplierClientBank/", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateSupplierBankInfo(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("supplierClientBank/update", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {}
};
